module.exports = __webpack_public_path__ + "img/up-arrow.6460c845.svg";